import { createNamespacer, createReducer } from "../utils/reducers";

const namespacer = createNamespacer("CART");

const initialState = {
  count: 0,
  cartDetails: null,
};

const handlers = {
  [namespacer("CLEAR_CART")]: (state: any, action: any) => {
    return { ...state, count: 0 };
  },
  [namespacer("SET_COUNT")]: (state: any, action: any) => {
    const count =
      typeof action.payload === "object"
        ? action.payload.count
        : action.payload;
    return { ...state, count: count ?? 0 };
  },
  [namespacer("SET_CART_DETAILS")]: (state: any, action: any) => {
    console.log("cartDetails", action.payload)
    return {
      ...state,
      cartDetails: action.payload.cartDetails,
    };
  },
};

const cart = createReducer(initialState, handlers, ["CART"]);

export default cart;
